import { ROWS_TO_FETCH } from '../constants';

/**
 * Get the number of items per page
 *
 * This will cap the number of items to 4 per page.
 */
const getNbItemsPerPage = (itemsPerRow) =>
  Math.min(4, itemsPerRow * ROWS_TO_FETCH);

export default getNbItemsPerPage;
